import React, { useEffect } from "react";
import { Typography, Row, Col, Card, Divider, Image } from "antd";
import axios from "axios";

const { Title, Paragraph } = Typography;

const AboutUs = () => {
  useEffect(() => {
    logUserActivity();
    document.title = "JOJ | About Us";
  }, []);

  const logUserActivity = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "5",
        DetailID: "0",
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  return (
    <div
      style={{
        background: "linear-gradient(to right, #fbc2eb, #a6c1ee)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
        borderRadius: 16,
      }}
    >
      <Card
        style={{
          maxWidth: 800,
          width: "100%",
          textAlign: "center",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          background: "rgba(255, 255, 255, 0.95)",
        }}
      >
        {/* Banner Image */}
        <Image
          src="https://thejoj.com/images/JOJAboutUS.jpg"
          alt="About us banner"
          style={{
            width: "100%",
            maxHeight: 400,
            objectFit: "cover",
            borderRadius: 12,
          }}
          preview={false}
        />

        {/* Title and Paragraph */}
        <Typography style={{ marginTop: 32 }}>
          <Title level={2} style={{ textAlign: "center" }}>
            About Us
          </Title>
          <Paragraph
            style={{
              textAlign: "center",
              fontSize: 16,
              maxWidth: 800,
              margin: "auto",
            }}
          >
            Welcome to our store! We specialize in exquisite traditional
            jewellery, celebrating cultural heritage with each handcrafted
            piece. From royal Rajputi Aad to intricate Kundan sets, we’re
            committed to quality, beauty, and customer satisfaction.
          </Paragraph>
        </Typography>

        <Divider />

        {/* Cards for Highlights */}
        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} md={8}>
            <Card
              title="Our Mission"
              bordered={false}
              style={{ borderRadius: 12, textAlign: "center" }}
            >
              <Paragraph>
                To empower and inspire confidence in every customer with
                traditional craftsmanship and timeless beauty.
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              title="Our Values"
              bordered={false}
              style={{ borderRadius: 12, textAlign: "center" }}
            >
              <Paragraph>
                We believe in honesty, quality, and preserving culture through
                every design and detail.
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              title="Our Story"
              bordered={false}
              style={{ borderRadius: 12, textAlign: "center" }}
            >
              <Paragraph>
                Started from a small shop, now serving thousands online with
                heritage-inspired jewellery worldwide.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default AboutUs;
